import React, { useContext, useEffect } from 'react';
import { UserSessionContext } from 'components/UserSession';
import styled from 'styled-components';

const Trigger = styled.div`
  width: 100%;
  height: 100%;
  user-select: none;
  cursor: pointer;
`;

const ZendeskTrigger = () => {
  const { userSession } = useContext(UserSessionContext);

  const userFullName = userSession?.fullName || '';

  useEffect(() => {
    const { $zopim } = window;
    if ($zopim) {
      $zopim(() => {
        $zopim.livechat.setName(userFullName);
      });
    }
  }, [userFullName]);
  return (
    <Trigger
      onClick={() => { $zopim.livechat.window.show(); }}
    />
  );
};

export default ZendeskTrigger;
